import { ThunkDispatch } from "redux-thunk";

import { getBaseStore } from "@utils/configuration/aem";

import CreateApiModule from "@redux/create-api-module";
import { IState, TApiAction, TExtraThunkArgs } from "@redux/store.types";

import BoxCountReducer from "./boxCount.reducer";
import { $BoxCountModuleName } from "./boxCount.types";

const { actions } = CreateApiModule(
    $BoxCountModuleName,
    ({ url }) => `${url}`,
    {
        reducer: BoxCountReducer,
    },
);

export const clear = actions.clear;

export const load =
    (sku: string, force: boolean = false) =>
    (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) => {
        return dispatch(
            actions.load(
                {
                    path: {
                        url: `/productservice/${getBaseStore()}/box/${sku}/count`,
                    },
                },
                "GET",
                force,
                {
                    discriminator: sku,
                },
            ),
        );
    };

export const refetch = actions.refetch;
